import { FC, MouseEventHandler } from "react";

export const NavigationSuppressor: FC<{ children }> = ({ children }) => {

  const onClickCapture: MouseEventHandler<HTMLDivElement> = (e) => {
    if (e.target instanceof Element && e.target.closest('a[href], button, input[type="submit"], input[type="button"]')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  return <div onClickCapture={onClickCapture}>
    {children}
  </div>;
}